import React from 'react';

import { EOrganization, ESnapshotExists } from 'lib/types';
import { PublicationIssueModel } from 'lib/model/objects/publicationIssueModel';
import { CopyText } from 'lib/components/CopyText';

type PublicationIssueDrawerHeaderProps = {
  publicationIssue: PublicationIssueModel;
  publisher: ESnapshotExists<EOrganization>;
};

export default function PublicationIssueDrawerHeader({
  publicationIssue,
  publisher
}: PublicationIssueDrawerHeaderProps) {
  const { publicationDate } = publicationIssue.modelData;

  return (
    <div className="w-full space-y-2">
      <h2 className="font-semibold text-xl max-w-md truncate">
        {publisher.data().name} {publicationDate}
      </h2>
      <div className="text-sm">
        <span className="font-bold block">Publication Issue ID</span>
        <CopyText copyText={publicationIssue.id}>
          {publicationIssue.id}
        </CopyText>
      </div>
    </div>
  );
}
